import { ConceptsData, OverallPerformanceData } from '../performanceDrawerData';
import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import {
  Drawer,
  Box,
  Typography,
  Button,
  DrawerProps,
  SxProps,
} from '@mui/material';
import { ConceptItem } from '../../ConceptItem';

type ConceptSectionProps = {
  data?: ConceptsData;
};
const drawerStyles = {
  card: {
    backgroundColor: '#fff',
    // borderRadius: pxToRem(16),
    // padding: pxToRem(18),
    // margin: `${pxToRem(14)} ${pxToRem(18)} 0`,
    // boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
};
export const ConceptSection = ({ data }: ConceptSectionProps) => {
  if (!data) return null;

  const { noOfAttempted, noOfMastered, list } = data;

  return (
    <Box sx={drawerStyles.card}>
      {/* HEADER */}
      <Box sx={drawerStyles.cardHeader}>
        <Box display={'flex'} gap={2}>
          <Typography fontSize={pxToRem(18)}>📚</Typography>

          {/* TITLE → cardText */}
          <Typography
            variant="cardText"
            sx={{
              fontFamily: 'Poppins',
              color: '#1e293b',
            }}
          >
            Concepts
          </Typography>
        </Box>

        {/* BADGE */}
        {!!noOfAttempted && (
          <Box
            sx={{
              fontFamily: 'Lato',
              fontWeight: 700,
              fontSize: pxToRem(12),
              px: pxToRem(10),
              py: pxToRem(3),
              borderRadius: pxToRem(20),
              background: '#eef2ff',
              color: '#667eea',
            }}
          >
            {noOfMastered} mastered / {noOfAttempted} attempted
          </Box>
        )}
      </Box>

      {/* LIST */}
      <Box
        display="flex"
        flexDirection="column"
        gap={pxToRem(10)}
        mt={pxToRem(14)}
      >
        {list.map((item, idx) => (
          <ConceptItem key={idx} data={item} />
        ))}
      </Box>
    </Box>
  );
};
